











































import { ApiResponse } from 'apisauce';
import { Component, Vue } from 'vue-property-decorator';
import ActivityIndicator from '../components/ActivityIndicator.vue';
import api from '../api';

@Component({
  components: {
    ActivityIndicator,
  },
  data() {
    return {
      loading: true,
      selectedBlog: null,
      devLogs: [],
    };
  },
})

export default class DevLog extends Vue {
  private mounted() {
    const id = typeof this.$route.params.id === 'string' && !isNaN(Number(this.$route.params.id))
      ? Number(this.$route.params.id)
      : false;

    if (id) {
      this.setLog(id);
    } else {
      this.fetchBlogs();
    }
  }
  private navigateTo(id: any) {
    if (!id) {
      this.$router.replace(`/devlog`);
      this.fetchBlogs();
    } else {
      this.$router.replace(`/devlog/${id}`);
      this.setLog(id);
    }
  }
  private fetchBlogs() {
    this.$data.loading = false;
    this.$data.selectedBlog = null;
    this.$data.devLogs = [];

    api.get('/devlog')
    .then((res: ApiResponse<any>) => {
      const body = res.data;

      if (res.ok) {
        this.$data.devLogs = body.data;
      }

      this.$data.loading = false;
    });
  }
  private setLog(id: any) {
    this.$data.loading = true;
    api.get(`/devlog/${id}`)
    .then((res: ApiResponse<any>) => {
      this.$data.loading = false;
      if (res.ok) {
        const body = res.data;
        this.$data.selectedBlog = body.data;
      } else {
        this.showError('Could not load html');
      }
    });
  }
  private showError(err: string) {
    alert(err);
  }
}
